// Mock data for ZOOM ACADEMY

export const courses = [
  {
    id: 1,
    title: "B.Sc Agriculture Entrance",
    subtitle: "CCS HAU, Hisar - 4 Year Program",
    description: "Complete preparation for HAU entrance with expert guidance in Physics, Chemistry, Biology/Mathematics, and Agriculture subjects. Regular mock tests, doubt sessions, and comprehensive study material.",
    duration: "4 Years Program",
    eligibility: "10+2 (PCM/PCB/Agriculture/CBA/PCA)",
    ageCriteria: "17-25 years",
    icon: "Sprout",
    bgImage: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?q=80&w=2070",
    route: "/course/bsc-agriculture-4year"
  },
  {
    id: 2,
    title: "B.Sc Agriculture Entrance",
    subtitle: "CCS HAU, Hisar - 6 Year Program",
    description: "Integrated 6-year program starting from 10th standard. Strong foundation building in Science, Mathematics, and Agriculture basics with step-by-step learning approach.",
    duration: "6 Years Program",
    eligibility: "10th Pass",
    ageCriteria: "15-20 years",
    icon: "Sprout",
    bgImage: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?q=80&w=2070",
    route: "/course/bsc-agriculture-6year"
  },
  {
    id: 3,
    title: "B.Sc Fisheries",
    subtitle: "Professional Course",
    description: "Specialized coaching for Fisheries entrance covering Aquaculture, Fish Biology, and related subjects. Practical knowledge combined with theoretical concepts for exam success.",
    duration: "4 Years Program",
    eligibility: "10+2 with Science/PCA",
    ageCriteria: "17-25 years",
    icon: "Fish",
    bgImage: "https://images.unsplash.com/photo-1535591273668-578e31182c4f?q=80&w=2070",
    route: "/course/bsc-fisheries"
  },
  {
    id: 4,
    title: "B.Sc Nursing",
    subtitle: "Medical Stream",
    description: "Comprehensive preparation for Nursing entrance exams covering Physics, Chemistry, Biology with focus on medical concepts. Previous year papers and regular assessments included.",
    duration: "4 Years Program",
    eligibility: "10+2 with PCB",
    ageCriteria: "17-35 years",
    icon: "HeartPulse",
    bgImage: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?q=80&w=2091",
    route: "/course/bsc-nursing"
  },
  {
    id: 5,
    title: "VLDA (LUVAS)",
    subtitle: "Veterinary Course",
    description: "Complete VLDA preparation with focus on Veterinary Science, Animal Husbandry, and related subjects. Expert faculty with practical experience in veterinary field.",
    duration: "2 Years Program",
    eligibility: "12th with any stream",
    ageCriteria: "17-30 years",
    icon: "Stethoscope",
    bgImage: "https://images.unsplash.com/photo-1548681528-6a5c45b66b42?q=80&w=2069",
    route: "/course/vlda"
  },
  {
    id: 6,
    title: "11th & 12th Foundation",
    subtitle: "CBSE/State Board",
    description: "Strong foundation for Medical and Non-Medical streams. Complete syllabus coverage with NCERT focus, regular tests, and conceptual clarity for board exams preparation.",
    duration: "1-2 Years",
    eligibility: "10th Pass",
    ageCriteria: "15-18 years",
    icon: "BookOpen",
    bgImage: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=2070",
    route: "/course/foundation-11-12"
  },
  {
    id: 7,
    title: "CUET (UG)",
    subtitle: "Common University Entrance Test",
    description: "Domain-specific preparation covering all subjects for central university admissions. Language section, General Test, and subject-wise detailed coaching with mock tests.",
    duration: "6-12 Months",
    eligibility: "12th Pass",
    ageCriteria: "17-25 years",
    icon: "GraduationCap",
    bgImage: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=2070",
    route: "/course/cuet"
  },
  {
    id: 8,
    title: "NEET (UG)",
    subtitle: "Medical Entrance",
    description: "Intensive NEET coaching with Physics, Chemistry, Biology focus. Daily practice papers, NCERT-based teaching, and national-level mock tests for MBBS/BDS admission.",
    duration: "1-2 Years",
    eligibility: "10+2 with PCB",
    ageCriteria: "17-25 years",
    icon: "Stethoscope",
    bgImage: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=2070",
    route: "/course/neet"
  },
  {
    id: 9,
    title: "IIT-JEE",
    subtitle: "Engineering Entrance",
    description: "Expert coaching for JEE Main & Advanced covering PCM with advanced problem-solving techniques. Daily practice, concept building, and shortcuts for faster calculations.",
    duration: "1-2 Years",
    eligibility: "10+2 with PCM",
    ageCriteria: "17-25 years",
    icon: "Atom",
    bgImage: "https://images.unsplash.com/photo-1581093458791-9d42e377b7d5?q=80&w=2070",
    route: "/course/iit-jee"
  },
  {
    id: 10,
    title: "Haryana CET",
    subtitle: "State Level Entrance",
    description: "State-specific preparation for Haryana CET covering all UG/PG courses. Haryana board syllabus focus with previous year paper analysis and cut-off trends.",
    duration: "6-12 Months",
    eligibility: "10+2 / Graduation",
    ageCriteria: "17-35 years",
    icon: "School",
    bgImage: "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?q=80&w=2073",
    route: "/course/haryana-cet"
  },
  {
    id: 11,
    title: "HSSC",
    subtitle: "Haryana Staff Selection Commission",
    description: "Complete HSSC preparation covering Haryana GK, Reasoning, Quantitative Aptitude, Hindi, and English. Daily current affairs, shortcuts, and tricks for government job exams.",
    duration: "6-12 Months",
    eligibility: "10th / 12th / Graduation",
    ageCriteria: "18-42 years",
    icon: "Briefcase",
    bgImage: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=2070",
    route: "/course/hssc"
  },
  {
    id: 12,
    title: "Government Competitive Exams",
    subtitle: "SSC, Railway, Banking",
    description: "Comprehensive coaching for SSC, Railway, Banking, and other government exams. Current affairs, reasoning tricks, quantitative aptitude, and English preparation.",
    duration: "Flexible",
    eligibility: "As per exam requirement",
    ageCriteria: "18-35 years (varies)",
    icon: "Building",
    bgImage: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070",
    route: "/course/govt-exams"
  }
];

export const successStories = [
  {
    id: 1,
    name: "Kavish",
    course: "B.Sc Agriculture (HAU) 4 Year",
    achievement: "1st Rank - Haryana Topper 2025",
    marks: "95/100",
    rollNo: "76337",
    year: "2025",
    category: "GENERAL",
    image: "https://customer-assets.emergentagent.com/job_zoom-education-1/artifacts/mk2rgibe_IMG_2949.JPG.jpeg",
    testimonial: "ZOOM Academy की केंद्रित शिक्षा और व्यक्तिगत ध्यान ने मुझे HAU में 1st रैंक दिलाने में मदद की। संकाय की समर्पण अद्वितीय है।"
  },
  {
    id: 2,
    name: "Abhimanyu",
    course: "B.Sc Agriculture (HAU) 4 Year",
    achievement: "Rank 65 - EWS Category",
    marks: "65/100",
    rollNo: "80205",
    year: "2025",
    category: "EWS",
    image: "https://customer-assets.emergentagent.com/job_zoom-education-1/artifacts/hgx5guey_IMG_2978.JPG.jpeg",
    testimonial: "हिसार में ZOOM Best! मुझे HAU में admission मिला ZOOM Academy की वजह से।"
  },
  {
    id: 3,
    name: "Nishu",
    course: "B.Sc Nursing",
    achievement: "Selected - EWS Category",
    marks: "122/180",
    rollNo: "505846",
    year: "2025",
    category: "EWS",
    image: "https://customer-assets.emergentagent.com/job_zoom-education-1/artifacts/e5waqbal_IMG_4664.JPG.jpeg",
    testimonial: "ZOOM Academy की मेहनत से मुझे AGROHA Medical में B.Sc Nursing में selection मिला।"
  },
  {
    id: 4,
    name: "Deepak",
    course: "VLDD (LUVAS)",
    achievement: "1st Rank - EWS Category",
    marks: "91/100",
    rollNo: "1029",
    year: "2025",
    category: "EWS",
    image: "https://customer-assets.emergentagent.com/job_zoom-education-1/artifacts/qur3iugw_IMG_4297.JPG.jpeg",
    testimonial: "ZOOM Academy के expert guidance से मैंने VLDD में 1st Rank हासिल की।"
  },
  {
    id: 5,
    name: "Aman",
    course: "VLDD (LUVAS)",
    achievement: "2nd Rank - General Category",
    marks: "92/100",
    rollNo: "5881",
    year: "2025",
    category: "GENERAL",
    image: "https://customer-assets.emergentagent.com/job_zoom-education-1/artifacts/qur3iugw_IMG_4297.JPG.jpeg",
    testimonial: "ZOOM Academy में पढ़कर मैंने VLDD में 2nd Rank प्राप्त की। Best coaching in Hisar!"
  },
  {
    id: 6,
    name: "Paras",
    course: "B.Sc Life Science (HAU) 4 Year",
    achievement: "1st Rank - Haryana Topper 2025",
    marks: "77.5/100",
    rollNo: "82534",
    year: "2025",
    category: "GENERAL",
    image: "https://customer-assets.emergentagent.com/job_zoom-education-1/artifacts/3jj32qjl_IMG_3330.JPG.jpeg",
    testimonial: "HAU में Life Science में 1st Rank! ZOOM Academy ने मेरा सपना पूरा किया।"
  },
  {
    id: 7,
    name: "Sujata",
    course: "B.Sc Nursing",
    achievement: "Selected - EWS Category",
    marks: "127/180",
    rollNo: "511489",
    year: "2025",
    category: "EWS",
    image: "https://customer-assets.emergentagent.com/job_zoom-education-1/artifacts/bn2shc26_IMG_3712.JPG.jpeg",
    testimonial: "ZOOM Academy की coaching से मुझे ROHTAK PGI में B.Sc Nursing में selection मिला।"
  },
  {
    id: 8,
    name: "Dishant",
    course: "DVLT (LUVAS)",
    achievement: "Selected - General Category",
    marks: "84.5/100",
    rollNo: "",
    year: "2025",
    category: "GENERAL",
    image: "https://customer-assets.emergentagent.com/job_zoom-education-1/artifacts/bdphas3h_IMG_3855.JPG.jpeg",
    testimonial: "ZOOM Academy के teachers ने मुझे DVLT में success दिलाई।"
  }
];

export const scholarships = [
  {
    percentage: "90% & Above",
    discount: "50% Fee Waiver",
    color: "from-amber-500 to-yellow-500"
  },
  {
    percentage: "80% - 89%",
    discount: "30% Fee Waiver",
    color: "from-blue-500 to-cyan-500"
  },
  {
    percentage: "70% - 79%",
    discount: "20% Fee Waiver",
    color: "from-green-500 to-emerald-500"
  },
  {
    percentage: "60% - 69%",
    discount: "10% Fee Waiver",
    color: "from-indigo-500 to-blue-500"
  }
];

export const whyChooseUs = [
  {
    title: "Experienced Faculty",
    description: "Learn from expert teachers with years of experience in competitive exam coaching",
    icon: "Users"
  },
  {
    title: "Result-Oriented Teaching",
    description: "Proven track record with numerous toppers and selections in prestigious institutions",
    icon: "Target"
  },
  {
    title: "Small Batch Size",
    description: "Limited students per batch ensuring personalized attention to every student",
    icon: "UsersRound"
  },
  {
    title: "Regular Tests & Doubt Sessions",
    description: "Weekly mock tests and dedicated doubt clearing sessions for better understanding",
    icon: "ClipboardCheck"
  },
  {
    title: "Affordable Fees",
    description: "Quality education at reasonable fees with scholarship opportunities for meritorious students",
    icon: "IndianRupee"
  },
  {
    title: "Study Material",
    description: "Comprehensive study material designed by experts covering complete syllabus",
    icon: "BookOpenCheck"
  },
  {
    title: "Library Facility",
    description: "Well-equipped library with vast collection of books and peaceful study environment for students",
    icon: "Library",
    image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?q=80&w=2028"
  },
  {
    title: "Separate Hostels",
    description: "Different hostel facilities for boys and girls with proper security and home-like environment",
    icon: "Home"
  },
  {
    title: "Study Friendly Environment",
    description: "Peaceful and motivating atmosphere designed specifically for focused learning and exam preparation",
    icon: "Lightbulb"
  },
  {
    title: "Online & Offline Classes",
    description: "Flexible learning with both online and offline classes including special weekend batches for working students",
    icon: "Monitor"
  }
];

export const stats = [
  {
    number: "5000+",
    label: "Students Enrolled",
    icon: "Users"
  },
  {
    number: "1500+",
    label: "Successful Selections",
    icon: "Award"
  },
  {
    number: "95%",
    label: "Success Rate",
    icon: "TrendingUp"
  },
  {
    number: "10+",
    label: "Years Experience",
    icon: "Calendar"
  }
];

export const additionalResultImages = [
  "https://customer-assets.emergentagent.com/job_98529d53-1c35-46ad-aba2-5200ea95c0d0/artifacts/zq1w2m06_626038937_888747704135893_7391759998306269910_n.jpg",
  "https://customer-assets.emergentagent.com/job_98529d53-1c35-46ad-aba2-5200ea95c0d0/artifacts/na2gm2oa_592160256_838074832536514_8234065196897062549_n.jpg",
  "https://customer-assets.emergentagent.com/job_98529d53-1c35-46ad-aba2-5200ea95c0d0/artifacts/2jbsm4z3_594064966_842756472068350_1896003602254742368_n.jpg",
  "https://customer-assets.emergentagent.com/job_98529d53-1c35-46ad-aba2-5200ea95c0d0/artifacts/2pvktqdv_597860609_848033198207344_5281754436906928475_n.jpg",
  "https://customer-assets.emergentagent.com/job_98529d53-1c35-46ad-aba2-5200ea95c0d0/artifacts/03esmoay_609208294_864650333212297_1158308757331439835_n.jpg"
];

export const courseDetailsData = {
  'bsc-agriculture-4year': {
    title: 'B.Sc Agriculture (4 Year)',
    subtitle: 'CCS HAU Hisar',
    description: 'CCS Haryana Agricultural University ke liye comprehensive coaching program।',
    examDetails: ['100 MCQs', '2 घंटे', 'Physics, Chemistry, Biology/Math, Agriculture', '+4 सही, -1 गलत'],
    preparation: ['NCERT Books पढ़ें', 'Concept Building करें', 'Daily Mock Tests', 'Regular Revision', 'Time Management'],
    zoomHelp: ['Experienced Faculty', 'Study Material', 'Mock Tests', 'Doubt Sessions', 'Small Batches', 'Previous Papers']
  },
  'bsc-agriculture-6year': {
    title: 'B.Sc Agriculture (6 Year)',
    subtitle: 'CCS HAU Hisar - Integrated',
    description: '10th ke baad 6-year integrated program।',
    examDetails: ['80 MCQs', '2 घंटे', 'Science, Math, GK', '+4 सही, -1 गलत'],
    preparation: ['10th Level Concepts', 'Regular Practice', 'General Knowledge', 'Speed & Accuracy', 'Mock Tests'],
    zoomHelp: ['Foundation Building', 'Step by Step Learning', 'Regular Assessment', 'Simple Notes', 'Parent Meetings', 'Career Counseling']
  },
  'neet': {
    title: 'NEET (UG)',
    subtitle: 'Medical Entrance',
    description: 'Medical colleges mein MBBS/BDS admission ke liye।',
    examDetails: ['200 MCQs (180 attempt)', '3 घंटे 20 min', 'Physics (50), Chemistry (50), Biology (100)', '720 marks', '-1 गलत answer'],
    preparation: ['NCERT Focus - Biology', 'Chemistry तीनों parts', 'Physics Numerical daily', 'Previous 10 years papers', 'Mock Tests monthly', 'Short notes बनाएं'],
    zoomHelp: ['Expert Faculty', 'Daily Classes', 'DPP Daily', 'Mock Test Series', 'Complete Notes', 'Doubt Clearing', 'Toppers Guidance']
  },
  'iit-jee': {
    title: 'IIT-JEE',
    subtitle: 'Engineering Entrance',
    description: 'IITs, NITs mein admission ke liye JEE Main aur Advanced।',
    examDetails: ['90 MCQs (75 attempt)', '3 घंटे', 'Physics (30), Chemistry (30), Maths (30)', '300 marks'],
    preparation: ['NCERT + Advanced', 'Maths daily 4-5 hours', 'Physics Numerical + Theory', 'Chemistry Organic reactions', 'Previous Papers', 'Mock Tests'],
    zoomHelp: ['IIT Faculty', 'Study Material', 'Daily Practice Problems', 'Weekly Tests', 'Doubt Resolution', 'Online Test Series', 'Track Record']
  },
  'cuet': {
    title: 'CUET (UG)',
    subtitle: 'Common University Entrance',
    description: 'Central universities mein UG admission ke liye।',
    examDetails: ['Languages, Domain Subjects, General Test', '6 subjects choose करें', 'MCQ format', '45-60 min per section', 'Best 3 scores'],
    preparation: ['Domain Selection करें', 'NCERT Based', 'General Test practice', 'Language comprehension', 'Sample Papers'],
    zoomHelp: ['All Domain Subjects', 'Language Section', 'General Test Prep', 'Mock Tests', 'University Counseling', 'Subject Notes']
  },
  'haryana-cet': {
    title: 'Haryana CET',
    subtitle: 'State Entrance Test',
    description: 'Haryana state colleges mein admission।',
    examDetails: ['Subject-wise sections', 'MCQ format', '2-3 घंटे', '10+2 या graduation level', 'State Level'],
    preparation: ['Syllabus Focus', 'Previous 5 years papers', 'State Level prep', 'Time Management', 'Mock Tests'],
    zoomHelp: ['State Syllabus Experts', 'Previous Year Analysis', 'Regular Tests', 'Hindi + English', 'Admission Counseling', 'Cut-off Analysis']
  },
  'hssc': {
    title: 'HSSC',
    subtitle: 'Haryana Govt Jobs',
    description: 'Haryana government की various posts ke liye।',
    examDetails: ['GK, Reasoning, Quantitative, Hindi, English', '100 questions', '90 min - 2 घंटे', '-0.25 negative', 'Category-wise cut-off'],
    preparation: ['Haryana GK important', 'Current Affairs daily', 'Reasoning Puzzles', 'Maths shortcuts', 'Hindi Grammar', 'Previous Papers'],
    zoomHelp: ['Haryana GK Classes', 'Daily Current Affairs', 'Reasoning Tricks', 'Maths Shortcuts', 'Mock Test Series', 'Hindi Notes', 'Success Stories']
  }
};

export const youtubeVideos = [
  {
    id: 1,
    url: "https://youtube.com/shorts/51v1IAgPjMU",
    embedId: "51v1IAgPjMU",
    title: "ZOOM Academy Success Story"
  },
  {
    id: 2,
    url: "https://youtube.com/shorts/xFlgg0SXe1Q",
    embedId: "xFlgg0SXe1Q",
    title: "Student Achievement at ZOOM Academy"
  }
];
